import { injectScriptTag } from '@pb/utils'
import { compose } from 'ramda'

import { SCRIPT_URL } from 'features/klarna/constants'

const handleExists = (): any => ({
  loaded: true,
  error: false,
})

const handleLoaded = (): any => ({
  loaded: true,
  error: false,
})

const handleError = (): any => ({
  loaded: true,
  error: true,
})

const onStateUpdate = (currentStatus, Statuses): any => {
  switch (currentStatus) {
    case Statuses.EXISTS:
      return handleExists()
    case Statuses.LOADED:
      return handleLoaded()
    case Statuses.ERROR:
      return handleError()
    default:
  }
  return { loaded: false, error: false }
}

const klarnaPaymentsInitialize: any = async (clientToken): Promise<any> => {
  const { loaded, error } = await new Promise<any>((resolve) => {
    injectScriptTag({
      src: SCRIPT_URL.payments,
      onStateUpdate: compose(resolve, onStateUpdate),
    })
  })

  if (loaded && !error) {
    Klarna.Payments.init({
      client_token: clientToken,
    })
  }

  return [loaded, error]
}

export default klarnaPaymentsInitialize
